import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const AddUnitCategory = ({ show, onClose, onCreated , refresh}) => { 
        const baseURL = process.env.REACT_APP_API_BASE_URL;
        const [name, setName] = useState(''); 
        const [description, setDescription] = useState(''); 
        const [errors, setErrors] = useState({});
        const [nameLengthError, setNameLengthError] = useState('');
        const [descLengthError, setDescLengthError] = useState('');
    
        // Handle changes in department name and ensure first letter is uppercase
        const handleNameChange = (e) => {
            let value = e.target.value; 
            // Capitalize the first letter
            value = value.charAt(0).toUpperCase() + value.slice(1);
            setName(value);
    
            // Clear name length error if input length is under the limit
            if (value.length <= 300) {
                setNameLengthError('');
            }
        };
    
        // Handle changes in description and ensure first letter is uppercase
        const handleDescriptionChange = (e) => {
            let value = e.target.value;
            // Capitalize the first letter
            value = value.charAt(0).toUpperCase() + value.slice(1);
            setDescription(value);
    
            // Check the length of the description and set error if exceeds 500
            if (value.length > 500) {
                setDescLengthError('Limit reached (max 500 characters)');
            } else {
                setDescLengthError('');
            }
        };
    
     
    
        const handleSubmit = () => {
            // Clear previous errors
            setErrors({});
            setNameLengthError('');
            setDescLengthError('');
        
            // Validation for department name 
            if (!name) {
                setErrors(prev => ({
                    ...prev,
                    unitcategory_name: "This field is required"
                }));
                return;
            }
        
            // Validation for length of department name
            if (name.length > 300) {
                setNameLengthError('Limit reached (max 300 characters)');
                return;
            }
        
            if (description.length > 500) {
                setDescLengthError('Limit reached (max 500 characters)'); 
                return;
            }
        
            // Proceed with API call if validation passes
            axios.post(`${baseURL}/unitcategory`, { 
                unitcategory_name: name,
                description: description,
            })
            .then(() => {
                onClose();
                refresh();
                if (onCreated) onCreated(); // Refresh list after add
                // window.location.reload();
                toast.success("Unit Category Created successfully!");
            })
            .catch(error => {
                if (error.response?.status === 400) {
                    // Check if the error response contains a message about the department already existing
                    if (error.response.data?.message === 'Unit Catgeory already exists') {
                        setErrors(prev => ({
                            ...prev,
                            unitcategory_name: 'Unit Category with this name already exists'
                        }));
                    } else if (error.response.data.errors) {
                        // Handle other validation errors
                        setErrors(error.response.data.errors);
                    }
                } else {
                    console.error("Create failed:", error);
                    toast.error("Create failed:");
                }
            });
        };
    
        
   
    return ( 
        <>
            <Modal className="modal fade" show={show}  size="md">
                <div className="modal-content">
                    <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                        <h3 className="modal-title text-white">Create Unit Category</h3>
                        <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal"   onClick={onClose}>
                            <span className='text-white'>×</span>
                        </Button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-lg-12 mb-4">
                                <label className="text-black font-w500 fs-7">Unit Category Name<span className="required">*</span></label>
                                <input type="text" 
                                 className={`form-control ${errors.unitcategory_name ? 'is-invalid' : ''}`}
                                placeholder="Enter Unit Category" 
                                value={name}
                                onChange={handleNameChange}
                                />
                                {errors.unitcategory_name && (
                                <div className="invalid-feedback">{errors.unitcategory_name}</div>
                            )}
                            {nameLengthError && (
                                <span className="text-danger">{nameLengthError}</span>
                            )}
                            </div>
                            <div className="col-lg-12 mb-4">
                                <label className="text-black font-w500 fs-7">Description</label>
                                <textarea
                                rows={4}
                                className={`form-control ${errors.description ? 'is-invalid' : ''}`}
                                placeholder="Description"
                                value={description}
                                onChange={handleDescriptionChange}
                            />
                            {descLengthError && (
                                <span className="text-danger">{descLengthError}</span>
                            )}
                            </div>
                        </div>
                        
                        <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                            <button type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Create Unit Category
                            <i className="fas fa-angle-double-right ms-2"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default AddUnitCategory; 
